import React from "react";
import { PageShell } from "../components/PageShell";

export default function NotFoundPage() {
  return (
    <PageShell title="Pagina niet gevonden">
      <div data-testid="not-found" className="rounded-lg border border-slate-200 bg-white p-6 text-center">
        <h1 className="text-2xl font-semibold">Deze link is niet meer geldig</h1>
        <p className="mt-3 text-sm text-slate-700">
          Mogelijk is uw aanmeldlink verlopen, of klikte u op een oude link. Vraag uw werkgever om een
          nieuwe link of mail naar{" "}
          <a className="text-blue-700 underline" href="mailto:info@fulkraworks.nl">info@fulkraworks.nl</a>.
        </p>
      </div>
    </PageShell>
  );
}
